import { Injectable } from '@angular/core';
import { SERVER_API } from '../../config/config';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class CompilacionService {

  constructor(
    public http: HttpClient
  ) { }

  obtenerBateo(json : any){
    let url = SERVER_API+"compilacion/obtenerBateo";
    return this.http.post( url, json )
      .pipe(map( (resp: any) => {
        return resp;
      }), catchError(err => {
        Swal.fire("Ha ocurrido un error", err.error.message, 'error');
        return throwError(err);
      }));
  }

  obtenerPitcheo(json : any){
    let url = SERVER_API+"compilacion/obtenerPitcheo";
    return this.http.post( url, json )
      .pipe(map( (resp: any) => {
        return resp;
      }), catchError(err => {
        Swal.fire("Ha ocurrido un error en el Pitcheo", err.error.message, 'error');
        return throwError(err);
      }));
  }

  obtenerJornadaCompilacion(){
    let url = SERVER_API+"compilacion/obtenerJornadaCompilacion";
    return this.http.get( url )
      .pipe(map( (resp: any) => {
        return resp;
      }));
  }
}
